const state = {
}
  
const mutations = {
    TOGGLE_SIDEBAR: state => {
      state.sidebarIsClose = !state.sidebarIsClose;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    }
}
  
const actions = {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    logout () {
      sessionStorage.clear();
    }
}
  
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
  


// WEBPACK FOOTER //
// ./src/store/modules/sea.js